import { motion, Variant } from 'motion/react'
import { useEffect, useState } from 'react'
import { sleep } from 'utils'
import { panelPadding, panelRadius } from '../../utils/globals'
import { useScale } from '../../utils/scaleUtils'
import { StepPosition } from '../../utils/traitUtils'
import GlassPanel from '../GlassPanel'
import { SViewProps } from '../scaled'

interface Props extends Omit<SViewProps, 'position'> {
  position: StepPosition
}

export default function AnimatedPanel({ position, ...rest }: Props) {
  const scale = useScale()
  const [display, setDisplay] = useState('flex')

  useEffect(() => {
    if (position !== 'complete') setDisplay('flex')
    else sleep(500).then(() => setDisplay('none'))
  }, [position])

  return (
    <motion.div
      animate={position}
      initial={position}
      style={{
        backdropFilter: 'blur(10px)',
        borderRadius: panelRadius * scale,
        display,
        inset: 0,
        position: 'absolute',
      }}
      transition={{ ease: 'easeInOut', duration: 0.5 }}
      variants={animations}
    >
      <GlassPanel
        p={panelPadding}
        pb={0}
        flex={1}
        justifyContent="center"
        backdropFilter=""
        {...rest}
      />
    </motion.div>
  )
}

const animations: Record<StepPosition, Variant> = {
  complete: { x: '-80%', scale: 0.5, y: '15%', opacity: 0 },
  current: { x: '0%', scale: 1, y: 0, opacity: 1, zIndex: 0 },
  pending: { x: '150%', scale: 1, y: '20%', opacity: 0 },
}
